"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const loanCustomerInfo_1 = __importDefault(require("../../components/customerInfo/loanCustomerInfo"));
const internalLoanCustomerInfo_1 = __importDefault(require("../../components/customerInfo/internalLoanCustomerInfo"));
const internalLoanDetails_1 = __importDefault(require("../../components/loanDetails/internalLoanDetails"));
const styles_1 = __importDefault(require("../../styles/styles"));
const loanDetails_1 = __importDefault(require("../../components/loanDetails/loanDetails"));
const historyBox_1 = __importDefault(require("../../components/historyBox/historyBox"));
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const typesConstants_1 = require("../../constants/typesConstants");
const spinner_1 = __importDefault(require("../../components/spinner/spinner"));
const messageComponent_1 = __importDefault(require("../../components/messageComponent/messageComponent"));
const colors_1 = __importDefault(require("../../styles/colors"));
const utils_1 = require("../../utils/utils");
const boxTitle_1 = __importDefault(require("../../components/boxTitle/boxTitle"));
const actionHistoryTable_1 = __importDefault(require("../../components/historyBox/actionHistoryTable/actionHistoryTable"));
const defaultProps = {
    displayActions: true,
};
const LoanComponent = () => {
    const { schedule, loan, loadingStatus, errorMessage } = useAppSelector_1.default((state) => ({
        loadingStatus: state.schedule.status,
        callerInbound: state.communication.callerInbound,
        schedule: state.schedule.schedule,
        loan: state.schedule.loan,
        user: state.auth.user,
        errorMessage: state.schedule.errorMessage,
    }));
    const isDesktop = useWebDesktopDesign_1.default();
    const containerStyle = isDesktop ? styles_1.default.allScreenWeb : styles_1.default.allScreenMobile;
    const containerCustomerVoip = isDesktop ? [styles_1.default.flexDirectionRow] : [];
    const callContainerStyle = isDesktop && styles_1.default.flexOne;
    if (loadingStatus === typesConstants_1.FAILED_STATUS)
        return react_1.default.createElement(messageComponent_1.default, { message: errorMessage, color: colors_1.default.RED, icon: free_solid_svg_icons_1.faExclamationCircle });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        loadingStatus === typesConstants_1.PENDING_STATUS && react_1.default.createElement(spinner_1.default, null),
        !!loan && !!schedule && (react_1.default.createElement(react_native_1.View, { style: containerStyle }, utils_1.isInternalLoan(loan) ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_native_1.View, { style: containerCustomerVoip },
                react_1.default.createElement(react_native_1.View, { style: callContainerStyle },
                    react_1.default.createElement(internalLoanCustomerInfo_1.default, { loan: loan }))),
            react_1.default.createElement(react_native_1.View, null,
                react_1.default.createElement(internalLoanDetails_1.default, { loanData: loan.loan_data })),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.boxStyles },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, { zIndex: 10 }] },
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.alignCenterStart },
                        react_1.default.createElement(boxTitle_1.default, { title: "History" }))),
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(actionHistoryTable_1.default, { historyActions: loan.loan_history }))))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_native_1.View, { style: containerCustomerVoip },
                react_1.default.createElement(react_native_1.View, { style: callContainerStyle },
                    react_1.default.createElement(loanCustomerInfo_1.default, { loan: loan, scheduleId: schedule.id }))),
            react_1.default.createElement(react_native_1.View, null,
                react_1.default.createElement(loanDetails_1.default, { loanData: loan.loan_data, actions: loan.available_actions })),
            react_1.default.createElement(react_native_1.View, null,
                react_1.default.createElement(historyBox_1.default, { previousStages: loan.loan_history.previous_stages, currentStage: loan.loan_history.current_stage, nextStages: loan.loan_history.next_stages, actions: loan.loan_history.actions }))))))));
};
LoanComponent.defaultProps = defaultProps;
exports.default = LoanComponent;
